import React from 'react';
import { PICKUP_RATE_ZONE_TYPE } from '../../../pricing/components/consts';
import { FormMultiSelect, FormSelect, } from '../formControls';
import { MOVE_TYPE_CONTAINER_MANAGEMENT } from '../../constants/enums';
import { useGetRateZones } from 'src/fetch/rateZones';
import { emptyArray } from 'src/shared/helpers/utils';

const SYSTEM_RATE_ZONE_ID = -1;

const PickupRateZonesDropdown = ({ terminalId, isMultiSelect = true, quoteMoveType, ...props }) => {
  const { data } = useGetRateZones();
  const pickupRateZones = (data || emptyArray)
    .filter(({ rateZoneType, marketId, id }) => rateZoneType === PICKUP_RATE_ZONE_TYPE
      && (!terminalId || marketId === terminalId)
      && (quoteMoveType === MOVE_TYPE_CONTAINER_MANAGEMENT || id !== SYSTEM_RATE_ZONE_ID))
    .map(({ id, name, marketName, latitude, longitude }) => ({
      value: id,
      label: `${name}, ${marketName}`,
      coordinates: { latitude, longitude },
    }));

  return isMultiSelect ? (
    <FormMultiSelect data={pickupRateZones} textField='label' dataItemKey='value' {...props} />
  ) : (
    <FormSelect data={pickupRateZones} textField='label' dataItemKey='value' {...props} />
  );
};

export default PickupRateZonesDropdown;
